import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNDepartment } from 'src/app/models/cndepartment';
import { CNUser } from 'src/app/models/cnuser';
import { BecareConfigService } from 'src/app/services/becare-config.service';
import { UserDepartmentService } from 'src/app/services/user/user-department.service';

@ManageType('UserDepartmentsAdminDialogComponent')
@Component({
  selector: 'app-user-departments-admin-dialog',
  templateUrl: './user-departments-admin-dialog.component.html',
  styleUrls: ['./user-departments-admin-dialog.component.scss']
})
export class UserDepartmentsAdminDialogComponent implements OnInit {

  public department: CNDepartment = new CNDepartment();
  public newdepartment = '';
  public departmentUsers: CNUser[] = [];
  private selectedUser: CNUser;

  constructor(private departmentSrv: UserDepartmentService) { }

  ngOnInit(): void {
  }

  public selectDepartment(department: CNDepartment) {
    this.department = department;
    this.department.users().subscribe(users => {
      this.departmentUsers = users;
    });
  }

  public addDepartment() {
    this.departmentSrv.addDepartment(this.newdepartment);
    this.department.users().subscribe(users => {
      this.departmentUsers = users;
    });
  }

  public selectUser(user: CNUser) {
    this.selectedUser = user;
  }

  public addUser() {
    this.department.addUser(this.selectedUser).subscribe(users => {
      this.departmentUsers = users;
    });
  }

  public removeUser(user: CNUser): void {
    this.department.removeUser(user).subscribe(users => {
      this.departmentUsers = users;
    });
  }
}
